import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { AttributeDto } from '@emi/shared/models';
import * as Constants from '@emi/shared/constants';
import { HttpService } from '../http.service';

@Injectable({
  providedIn: 'root',
})
export class AttributesService {
  constructor(private httpService: HttpService) {}

  public getAttributes(filterData: object): Observable<AttributeDto> {
    return this.httpService.postHttp<AttributeDto>(
      Constants.ServiceConstants.ATTRIBUTES,
      filterData
    );
  }
}
